import { useCallback, useEffect, useState } from "react";
import Section from "../../components/Section/Section";
import Crt from "../../components/Minigames/Crt/Crt";
import Cutout from "../../components/Cutout/Cutout";
import parser from "html-react-parser";
import Cartridge from "../../components/Minigames/Cartridge/Cartridge";
import { minigamesData } from "../../data/minigames";
import useWindowSize from "../../hooks/useWindowSize";
import styles from "./Minigames.module.css";

function Minigames() {
    const [currentGameIndex, setCurrentGameIndex] = useState(-1);
    const { width } = useWindowSize();

    const getPadFactor = useCallback((height, width) => {
        if (height === 600) {
            return 0.18;
        } else if (width === 600) {
            return 0.12;
        } else {
            return 0.15;
        }
    }, []);

    const resizeIframe = useCallback(() => {
        const iframe = document.querySelector(`#${styles.game_iframe}`);
        const cont = document.querySelector("#crt-content"); // todo: change to use ref?
        // const calcPad = getComputedStyle(cont).padding.replace('px', '')
        const i = currentGameIndex === -1 ? 0 : currentGameIndex;
        const padding =
            2 *
                (getPadFactor(minigamesData[i].width, minigamesData[i].height) *
                    cont.offsetWidth) +
            80;
        // console.log(padding)
        // scale the iframe down so that the longest dimension fits in the container
        // calculate a ratio to use with css scaling
        const ratio = Math.max(
            Math.min(
                (cont.offsetWidth - padding) / iframe.offsetWidth,
                (cont.offsetHeight - padding) / iframe.offsetHeight,
            ),
            0 / iframe.offsetWidth,
        );

        // scale the iframe
        iframe.style.scale = `${ratio}`;

        document
            .querySelector(":root")
            .style.setProperty("--crt-width", `${cont.offsetWidth}px`);
    }, [currentGameIndex, getPadFactor]);

    // useEffect(()=> {
    //     changeGame(0)
    // }, [])

    useEffect(() => {
        resizeIframe();
    }, [width, currentGameIndex, resizeIframe]);

    const changeGame = (index) => {
        const current = document.querySelector("[data-current-game]");
        const next = document.querySelector("[data-index='" + index + "']");
        let order = 0;
        if (current) {
            order = Number(current.getAttribute("index"));
            current.removeAttribute("data-current-game");
        }
        if (next) {
            next.setAttribute("data-current-game", "true");
            next.style.order = order;
        } else {
            console.log("no next", current, next, index);
        }

        setCurrentGameIndex(index);
    };

    const cartridges = minigamesData.map((game, index) => {
        return (
            <Cartridge
                key={game.title}
                index={index}
                onClick={() => {
                    changeGame(index);
                }}
                img={`/images/minigames/thumbnails/${game.img}.png`}
                title={game.short || game.title}
            />
        );
    });

    return (
        <div
            className={["page-main", styles.minigames_main].join(" ")}
            onScroll={console.log}
        >
            <Section id="minigames" onScroll={console.log}>
                <div className={styles.minigames_content}>
                    <div className={styles.game_container}>
                        <div className={styles.game_info}>
                            <Cutout id="minigame-cutout">
                                <h1 className={styles.game_title}>
                                    {currentGameIndex === -1
                                        ? "Minigames"
                                        : minigamesData[currentGameIndex].title}
                                </h1>
                            </Cutout>
                            <h3 className={styles.game_description}>
                                {currentGameIndex === -1
                                    ? "Click on a game cartdrige below to play!"
                                    : minigamesData[currentGameIndex]
                                          .description}
                            </h3>
                            <br />
                            <h2 id={styles.game_controls_heading}>
                                {currentGameIndex === -1 ? "" : "Controls"}
                            </h2>
                            <h3>
                                {parser(
                                    currentGameIndex === -1
                                        ? ""
                                        : minigamesData[currentGameIndex]
                                              .controls,
                                )}
                            </h3>
                        </div>
                        <Crt
                            bgColor={
                                currentGameIndex === -1
                                    ? "transparent"
                                    : minigamesData[currentGameIndex].bgColor
                            }
                            text={
                                currentGameIndex === -1
                                    ? "Input 3"
                                    : minigamesData[currentGameIndex].title
                            }
                            onClick={() => {
                                // changeGame((currentGameIndex + 1) % minigames.length)
                            }}
                        >
                            <iframe
                                id={styles.game_iframe}
                                title="game"
                                src={
                                    currentGameIndex === -1
                                        ? ""
                                        : `https://www.khanacademy.org/computer-programming${minigamesData[currentGameIndex].url}embedded?editor=no&buttons=no&author=no&embed=yes`
                                }
                                width={
                                    currentGameIndex === -1
                                        ? 0
                                        : minigamesData[currentGameIndex].width
                                }
                                height={
                                    currentGameIndex === -1
                                        ? 0
                                        : minigamesData[currentGameIndex].height
                                }
                                frameBorder="0"
                                scrolling="no"
                                border="0"
                                style={{
                                    minWidth:
                                        currentGameIndex === -1
                                            ? "100%"
                                            : minigamesData[currentGameIndex]
                                                  .width,
                                    minHeight:
                                        currentGameIndex === -1
                                            ? "100%"
                                            : minigamesData[currentGameIndex]
                                                  .height,
                                }}
                            />
                        </Crt>
                    </div>
                    <div className={styles.game_select_container}>
                        {cartridges}
                    </div>
                </div>
            </Section>
        </div>
    );
}

export default Minigames;
